var subobjects = {};

subobjects = {
  sing: "Einheit",
  plu: "Einheiten",
}

export default subobjects;